import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { getBorderRadius, HorizontalCard } from 'components/Card';
import { NotFoundErrorScreen } from 'components/screens';
import { Text } from 'components/Text';
import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import {
  DateFormat,
  DEFAULT_TIMEZONE,
  formatDateWithTimezone,
  getHoursAndMinutesLabel
} from 'utils/date';
import { useWeekDetails } from '../hooks';
import { ShiftsSkeleton } from './ShiftsSkeleton';

export const Shifts = () => {
  const { weekDetails, isLoading, isError } = useWeekDetails();
  const navigate = useNavigate();

  const shiftsIds = Object.keys(weekDetails?.shifts ?? {});

  if (isLoading) {
    return <ShiftsSkeleton />;
  }

  if (isError) {
    return (
      <NotFoundErrorScreen
        title={getTrans('weekDetailsPage.notFoundScreen.title')}
        description1={getTrans('weekDetailsPage.notFoundScreen.description1')}
        description2={getTrans('weekDetailsPage.notFoundScreen.description2')}
      />
    );
  }

  if (!weekDetails || !shiftsIds.length) return null;

  return (
    <Box>
      <Text variant="h5" align="center" sx={{ mb: 2 }}>
        {getTrans('weekDetailsPage.shifts.title')}
      </Text>
      {shiftsIds.map((id, index) => {
        const { shiftStart, shiftReportedMinutes } = weekDetails.shifts[id];
        return (
          <HorizontalCard
            key={`shift-${id}`}
            borderRadius={getBorderRadius(index, shiftsIds.length)}
            title={formatDateWithTimezone(
              shiftStart,
              DateFormat.WEEKDAY_WITH_MONTH,
              DEFAULT_TIMEZONE
            )}
            subtitle={getHoursAndMinutesLabel(shiftReportedMinutes)}
            onClick={() =>
              navigate(`${PATHS.shiftDetails}`.replace(':shiftId', id))
            }
          />
        );
      })}
    </Box>
  );
};
